let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("liLWD")).then(() => parcelRequire('dIoGB'));